<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {TaskTimeType} from "@/modules/redactor/models/worker/tasks/TaskTimeType";


export default {
  name: "r-task-time-type",
  props: {
    model: VueTypes.instanceOf(TaskTimeType),
    label: VueTypes.string.def("Time Type:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return TaskTimeType.getValues();
    }
  }
}
</script>
